import React from 'react'
import { Link } from 'react-router-dom'

export default function DynamicPageAi({ data }) {
  return (
    <>
      <section className="physical-security-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-10">
              <div className="physical-security-content">
                <h2 className="heading center-heading">{data?.head}</h2>
                <p dangerouslySetInnerHTML={{ __html: data?.desc }} />
              </div>
            </div>
          </div>

          <div className="row">

            {
              data?.boxes?.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-3">
                  <Link to={item?.slug}>
                    <div className="physical-security-box">
                      <img src={item?.img} alt="Physica Ssecurity Image" />
                      <span>{item?.label}</span>
                    </div>
                  </Link>
                </div>
              ))
            }

          </div>
        </div>
      </section>
    </>
  )
}
